<script>
  let { user, onSave, onCancel } = $props();

  let edited = $state({ ...user });
  let submitted = $state(false);

  function isValid() {
    return (
      !!edited.login &&
      !!edited.nazwa &&
      edited.nieudane !== undefined &&
      edited.nieudane !== null &&
      edited.nieudane !== "" &&
      (edited.blokada === 0 || edited.blokada === 1) &&
      !!edited.rola
    );
  }

  function ok(event) {
    event.preventDefault();
    submitted = true;
    if (isValid()) {
      onSave(edited);
    }
  }
</script>

<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel">{edited.hasOwnProperty("idau") ? "Edycja użytkownika" : "Utworzenie nowego użytkownika"}</h4>
</div>
<div class="modal-body">
  <div class="panel panel-default">
      <div class="panel-body">
            <form class="form form-inline" role="form" onsubmit={ok}>
            <table class="table table-condensed table-hover table-striped">
			<tbody>
			  <tr>
				<td>
				Login:
				</td>
                <td>
				<input type="text" class="form-control input-sm" placeholder="login" bind:value={edited.login} size="40" required>
				{#if submitted && !edited.login}
				<small style="color:red"><br>Trzeba wpisać login</small>
				{/if}
				</td>
			  </tr>
              <tr>
				<td>
				Imię i nazwisko:
				</td>
                <td>
				<input type="text" class="form-control input-sm" placeholder="imię i nazwisko" bind:value={edited.nazwa} size="40" required>
				{#if submitted && !edited.nazwa}
				<small style="color:red"><br>Trzeba wpisać imię i nazwisko</small>
				{/if}
				</td>
			  </tr>
              <tr>
				<td>
				Liczba nieudanych logowań (od ostatniego udanego):
				</td>
                <td>
				<input type="text" class="form-control input-sm" placeholder="nieudane" bind:value={edited.nieudane} size="40" required>
				{#if submitted && (edited.nieudane === undefined || edited.nieudane === null || edited.nieudane === "")}
				<small style="color:red"><br>Trzeba wpisać liczbę (jeśli nie wiesz, wpisz 0)</small>
				{/if}
				</td>
			  </tr>
              <tr>
				<td>
				Konto zablokowane:
				</td>
                <td>
                <select class="form-control input-sm" bind:value={edited.blokada} required>
				  <option value={0}>Nie</option>
                  <option value={1}>Tak</option>
				</select>
				{#if submitted && edited.blokada !== 0 && edited.blokada !== 1}
				<small style="color:red"><br>Trzeba wybrać opcję (jeśli nie wiesz, wybierz Nie)</small>
				{/if}
				</td>
			  </tr>
			  <tr>
				<td>
				Rola:
				</td>
                <td>
                <select class="form-control input-sm" bind:value={edited.rola} required>
				  <option value="admin">admin</option>
                  <option value="user">user</option>
				  <option value="koordynator">koordynator</option>
				</select>
				{#if submitted && !edited.rola}
				<small style="color:red"><br>Trzeba wybrać rolę</small>
				{/if}
				</td>
			  </tr>
              <tr>
				<td colspan="2">
                    <small class="text-muted">{edited.hasOwnProperty("idau") ? "" : 'Po dodaniu użytkownika (naciśnięciu "Zapisz") ustaw mu hasło wybierając "Ustaw hasło".'}</small>
				</td>
			  </tr>
			</tbody>
			</table>
            </form>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-success" onclick={ok}>Zapisz</button>
  <button class="btn btn-default" onclick={onCancel}>Anuluj</button>
</div>
